import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { currentUser } = useAuth();
  const profileStep = localStorage.getItem('profileStep');
  const userType = localStorage.getItem('userType');

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // For profile completion steps
  if (!requiredRole) {
    const currentPath = window.location.pathname;
    const steps = {
      '/profile/personal': 1,
      '/profile/address': 2,
      '/profile/education': 3,
      '/profile/skills': 4
    };

    const currentStepNumber = steps[currentPath];
    if (currentStepNumber && parseInt(profileStep) < currentStepNumber - 1) {
      const previousStep = Object.entries(steps).find(([_, value]) => value === currentStepNumber - 1);
      return <Navigate to={previousStep[0]} />;
    }
  }

  // For role-based routes
  if (requiredRole && userType !== requiredRole) {
    return <Navigate to={`/dashboard/${userType}`} />;
  }

  return children;
};

export default ProtectedRoute;